/**
 * CloseToRefButton
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import { useLocation, Link } from 'react-router-dom';
import usePersistentState from 'utils/usePersistentState.js';
import { useSearch } from 'utils/urlUtils.js';
import messages from './messages.js';

function CloseToRefButton(props) {
  const { className } = props;
  const [link, setLink] = usePersistentState(sessionStorage, 'closeToRefLink');
  const { ref } = useSearch();
  useEffect(() => {
    if (ref && ref !== link) {
      setLink(ref);
    }
  }, [ref]);
  if (!link) {
    return null;
  }
  return (
    <Button as={Link} variant="light" to={link} className={className}>
      <FormattedMessage {...messages.close} />
    </Button>
  );
}

CloseToRefButton.propTypes = {
  className: PropTypes.string,
};

export function useRefLink(link) {
  const { pathname, search, hash } = useLocation();
  const fullPath = `${pathname}${search}${hash}`;
  return `${link}?ref=${encodeURIComponent(fullPath)}`;
}

export default CloseToRefButton;
